/** Los dos botones de la sesión: cambiar de tema y salir. Van aparte porque los usan la barra
 * lateral y la pantalla «sin acceso». */
import { useEffect, useState } from 'react'

import { api } from '../api'

export function CambiarTema() {
  const [tema, setTema] = useState(() => {
    try {
      return localStorage.getItem('tema') ?? 'auto'
    } catch {
      return 'auto'
    }
  })

  useEffect(() => {
    // Una comodidad por navegador, nada más: si falla, la página se ve igual de bien.
    try {
      if (tema === 'auto') document.documentElement.removeAttribute('data-tema')
      else document.documentElement.setAttribute('data-tema', tema)
      localStorage.setItem('tema', tema)
    } catch {
      /* modo privado o almacenamiento bloqueado */
    }
  }, [tema])

  const siguiente = tema === 'auto' ? 'claro' : tema === 'claro' ? 'oscuro' : 'auto'
  const nombres: Record<string, string> = { auto: 'Automático', claro: 'Claro', oscuro: 'Oscuro' }

  return (
    <button className="enlace" onClick={() => setTema(siguiente)}>
      <span className="enlace__icono" aria-hidden="true">◐</span>
      Tema: {nombres[tema]}
    </button>
  )
}

export function Salir() {
  return (
    <button
      className="enlace"
      onClick={async () => {
        await api.post('/auth/logout').catch(() => undefined)
        window.location.href = '/'
      }}
    >
      <span className="enlace__icono" aria-hidden="true">⏻</span>
      Cerrar sesión
    </button>
  )
}
